import { Hint } from '@components/Hint/Hint';

export const HintPage = () => {
  return <Hint />;
};
